<template>
    <cell-card class="order-item-main">
        <div class="order-item__order-info-wrapper">
            <van-row type="flex" justify="space-between" class="order-item__header-info-wrapper">
                <!-- 店铺名 -->
                <van-col>
                    <van-row class="order-item__order-info-shop-wrapper" type="flex" align="bottom" gutter="1">
                        <van-col class="order-item__order-info-shop-icon-wrapper">
                            <van-icon class="order-item__order-info-shop-icon" size="16" name="shop-o" />
                        </van-col>
                        <span class="order-item__order-info-shop">海藻票务</span>
                    </van-row>
                </van-col>
                <van-col>
                    <span class="order-item__order-state">{{this.orderStateStr}}</span>
                </van-col>
            </van-row>
            <!-- 商品信息 -->
            <van-row class="order-item__goods-wrapper" type="flex">
                <!-- 商品头图 -->
                <van-col class="order-item__goods-avatar-wrapper">
                    <van-image class="ac-main__image" :src="coverPic" width="72" height="72"/>
                </van-col>
                <!-- 商品详细信息 -->
                <van-col class="order-item__goods-info-wrapper">
                    <van-row class="order-item__goods-info-title">{{skuName}}</van-row>
                    <van-row class="order-item__goods-info-num">x {{num}}</van-row>
                    <van-row class="order-item__goods-info-price" type="flex" justify="end">¥ {{skuPriceYuan}}</van-row>
                    <van-row v-if="itemInfoList && itemInfoList[0] && itemInfoList[0].rechargeAccount" class="order-item__goods-info-price" type="flex" justify="end">充值账号：{{itemInfoList[0].rechargeAccount}}</van-row>
                </van-col>
            </van-row>
            <!-- 订单总的价格信息 -->
            <van-row v-if="orderState == 'TO_SEND' || orderState == 'TO_RECEIVE' || orderState == 'SUCCESS' " type="flex" justify="end">
                    <span class="order-item__order-price-raw">总价<span class="order-item__order-price-currency"> ¥ </span>{{rawOrderPriceYuan}}，优惠<span class="order-item__order-price-currency"> ¥ </span>{{rawOrderPriceYuan}} <span class="order-item__order-price-actual">实付款<span class="order-item__order-price-currency"> ¥ </span>{{actualOrderPriceYuan}}</span></span> 
            </van-row>
            <!-- 订单操作按钮 -->
            <van-row type="flex" class="order-item__action-bar" justify="end" gutter="4">
                <van-col v-if="orderState === 'TO_PAY'">
                    <van-button size="small" round type="default" @click.stop="$emit('action', 'cancelOrder', {index, orderNo})">
                        取消订单
                    </van-button>
                </van-col>
                 <van-col v-if="orderState === 'TO_PAY'">
                    <van-button class="to-pay" size="small" round type="primary" color="#17161c" @click.stop="$emit('action', 'toPay', {index, orderNo})"> 
                        去支付
                    </van-button>
                </van-col>
                <van-col v-if="orderState === 'TO_RECEIVE'">
                    <van-button size="small" plain round color="#17161c" type="default" @click.stop="$emit('action', 'postSale', {index, orderNo, skuName, skuCode})">
                        发起售后
                    </van-button>
                </van-col>
                <van-col v-if="orderState === 'TO_RECEIVE'">
                    <van-button size="small" class="to-pay" round color="#17161c" type="primary" @click.stop="$emit('action', 'ensure', {index, orderNo})">
                        确认收货
                    </van-button>
                </van-col>
                <van-col v-if="orderState === 'POST_SALE'">
                    <van-button size="small" plain round color="#17161c" type="default" @click.stop="$emit('action', 'cancelPostSale', {index, orderNo})">
                        取消售后
                    </van-button>
                </van-col>
                <van-col v-if="orderState === 'SUCCESS' || orderState === 'TO_RECEIVE'">
                    <van-button size="small" plain round color="#17161c" @click.stop="$emit('action', 'viewTicket', {index, orderNo})">
                        查看卡券
                    </van-button>
                </van-col>
            </van-row>
        </div>
    </cell-card>
</template>

<script>
import CellCard from "@/components/CellCard.vue";
import {Col, Row, Icon, Image, Button} from "vant";
import {orderStateMap} from "@/constant.js";

export default {
    name: "tic-order-item-card",
    mixins: [],
    components: {
        [CellCard.name]: CellCard,
        [Col.name]: Col,
        [Row.name]: Row,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Button.name]: Button
    },
    props: {
        index: Number,
        orderState: String,
        orderNo: String,
        skuName: String,
        skuPrice: Number,
        num: Number,
        coverPic: String,
        skuCode: String,
        actualOrderPrice: Number,
        rawOrderPrice: Number,
        itemInfoList: Array
    },
    data() {
        return {};
    },
    computed: {
        orderStateStr: function() {
            return orderStateMap(this.orderState);
        },
        skuPriceYuan: function() {
            return (this.skuPrice / 100).toFixed(2);
        },
        actualOrderPriceYuan: function() {
            return (this.actualOrderPrice / 100).toFixed(2);
        }, 
        rawOrderPriceYuan: function() {
            return (this.rawOrderPrice / 100).toFixed(2);
        }
    },
    methods: {
    }
}
</script>

<style lang="less">
@import "@/style/base.less";
.order-item__order-info-wrapper {
    padding: 8px;
}

.order-item__header-info-wrapper {
    padding: 0 8px;
}

.order-item__order-info-shop-icon {
    vertical-align: middle;
}

.order-item__order-state {
    color: @font-color-secondary;
}

.order-item__order-info-shop {
    font-size: @font-size-normal;
    line-height: @line-height-normal;
    color: @font-color-normal;
    font-weight: @font-weight-normal;
}
.order-item__goods-wrapper {
    margin: 8px;
}

.order-item__goods-info-wrapper {
    flex-grow: 1;
    margin-left: 16px;
}
.order-item__goods-info-title {
    font-size: @font-size-title;
    color: @font-color-title;
    font-weight: @font-weight-title;
    line-height: @line-height-title;
}
.order-item__goods-info-num {
    text-align: right;
}

.order-item__goods-info-price {

}

.order-item__order-price-raw {
    font-size: @font-size-normal;
    color: @font-color-normal;
}

.order-item__order-price-actual {
    font-size: @font-size-normal;
    color: @font-color-title;
}

.order-item__order-price-currency {
    font-size: @font-size-mini;
}

.order-item__coupon-wrapper {
    .van-cell {
        padding: 10px 8px;
    }
}

.order-item__action-bar {
    .van-button {
        height: 30px;
    }
    .van-button--small {
        padding: 0 12px
    }

    .to-pay {
        color: @color-vice-font!important;
    }
}
</style>